const state = {
  tablesStates: {}
}

const getters = {
  getStateForTable: (state) => (identifier) => {
    return state.tablesStates[identifier]
  }
};

const actions = {

  persistTableState({commit}, data) {
    commit('didPersistTableState', data)
  },

  setFilterTable({commit}, filterObject) {
    commit('setFilterTableMut', filterObject)
  },

  setPropertyTableState({commit}, data) {
    commit('setPropertyTableState', data)
  }

}

const mutations = {

  didPersistTableState(state, data) {
    state.tablesStates[data.identifier] = data
  },

  setFilterTableMut(state, filtersObject) {
    state.tablesStates[filtersObject.tableName].filters = filtersObject.filters
  },

  setPropertyTableState(state, data) {
    state.tablesStates[data.identifier][data.property] = data.value
  }

}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/b122Table.js